export enum ReCaptchaAction {
	LOGIN = 'login',
}
